// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"60":"9386974f","235":"552d4399","310":"5d72fc27","425":"3f50736c","520":"467ff3a8","693":"235047a4","748":"36e574ee","789":"b1bcf126","851":"7c91935a","944":"126a2809"}[chunkId] + ".js";
};